import React, { useEffect, useRef, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const START_SECONDS = 17 * 60 + 34; // 00:17:34

function pad(n: number) {
  return n.toString().padStart(2, '0');
}
export function CountdownTimer() {
  const [remaining, setRemaining] = useState(START_SECONDS);
  const intervalRef = useRef<number | null>(null);
  useEffect(() => {
    intervalRef.current = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? START_SECONDS : prev - 1);
    }, 1000);
    return () => {
      if (intervalRef.current) window.clearInterval(intervalRef.current);
    };
  }, []);
  const hrs = Math.floor(remaining / 3600);
  const mins = Math.floor(remaining % 3600 / 60);
  const secs = remaining % 60;
  const Box = ({
    value,
    label
  }: {
    value: string;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-64" data-mp="34ra14327u8q7">
      <div className="min-w-[3.25rem] rounded-xl bg-[#35114f] px-3 py-2 text-center font-display text-3xl font-bold tabular-nums text-white shadow-inner sm:min-w-[3.75rem] sm:text-4xl" data-id="element-65" data-mp="34pyy45glh505">
        {value}
      </div>
      <span className="mt-1.5 text-[10px] font-semibold uppercase tracking-widest text-plum/70" data-id="element-66" data-mp="1c31dzd26yucr">
        {label}
      </span>
    </div>;
  return <div className="flex flex-col items-center gap-2" data-id="element-67" data-mp="123kan2aewsjy">
      <div className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-magenta" data-id="element-68" data-mp="171lu3obr2tvy">
        <ClockIcon className="h-4 w-4" data-id="element-69" data-mp="1urg500cie8dk" />
        <span data-id="element-70" data-mp="1ushhm996b2xe">La oferta termina en</span>
      </div>
      <div className="flex items-end gap-2" data-id="element-71" data-mp="1zq9i3rnvvxd7">
        <Box value={pad(hrs)} label="Horas" data-id="element-72" data-mp="1zoy5r3gdhhah" />
        <span className="pb-4 font-display text-2xl font-bold text-plum/40" data-id="element-73" data-mp="1l1d2n9jhzi2k">:</span>
        <Box value={pad(mins)} label="Min" data-id="element-74" data-mp="1kzadssu2zuzf" />
        <span className="pb-4 font-display text-2xl font-bold text-plum/40" data-id="element-75" data-mp="1pzocvldpfulb">:</span>
        <Box value={pad(secs)} label="Seg" data-id="element-76" data-mp="2dqak5afvxau9" />
      </div>
    </div>;
}